import React, { useState, useEffect, useRef, createRef, useMemo } from "react";
import {
  Constants,
  useMeeting,
  useParticipant,
  usePubSub,
  useWhiteboard,
} from "@videosdk.live/react-sdk";
import { PresenterView } from "../../components/PresenterView.js";
import ILSBottomBar from "../../interactive-live-streaming/components/ILSBottomBar.js";
import FlyingEmojisOverlay from "./FlyingEmojisOverlay.js";
import MemorizedILSParticipantView from "./ILSParticipantView.js";
import { useMeetingAppContext } from "../../MeetingAppContextDef.js";
import WaitingToJoinScreen from "../../components/screens/WaitingToJoinScreen.js";
import CustomDraggableReactPlayer from "./CustumDraggableReactPlayer.js";
import PopOverParticipantVideoRow from "PopOverParticipantRow.js";

export function ILSContainer({
  onMeetingLeave,
  setIsMeetingLeft,
  selectWebcamDeviceId,
  setSelectWebcamDeviceId,
  selectMicDeviceId,
  setSelectMicDeviceId,
  meetingMode,
  enableBgImage,
  WhiteBoardEnable,
  setWhiteBoardEnable,
  downloadFunctionCall,
  setDownloadFunctionCall,
  setLecturePdfFilePath,
  lecturePdfFilePath,
  clearWhiteBoardData,
  setClearWhiteBoardData,
  saveWhiteBoardData,
  setSaveWhiteBoardData,
  meetingRecord,
}) {
  const {
    useRaisedHandParticipants,
    setRaisedHandcountcontext,
    setNetworkStrengthOfParticipants,
    setMeetingRecord,
    whiteBoardOpenedBy,
    whiteboardUrlStored,
    whiteBoardActive
  } = useMeetingAppContext();
  const bottomBarHeight = 80;
  const topBarHeight = 56;

  const [containerHeight, setContainerHeight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [meetingError, setMeetingError] = useState(false);
  const [whiteboardStateInitialized, setWhiteboardStateInitialized] = useState(false);

  const [meetingErrorVisible, setMeetingErrorVisible] = useState(false);
  const mMeetingRef = useRef();
  const [localParticipantAllowedJoin, setLocalParticipantAllowedJoin] = useState();




  const { toggleScreenShare, participants } = useMeeting();

  const containerRef = createRef();
  const containerHeightRef = useRef();
  const containerWidthRef = useRef();


  useEffect(() => {
    containerHeightRef.current = containerHeight;
    containerWidthRef.current = containerWidth;
  }, [containerHeight, containerWidth]);

  const isMobile = false
  const [micAllowedParticipantsList, setMicAllowedParticipantList] = useState([]);
  const [webcamAllowedParticipantsList, setWebcamAllowedParticipantList] = useState(["IntialState"]);
  const [whiteboardAllowedStudents, setWhiteAllowedStudents] = useState([])
  const [screenShareRequested, setScreenShareRequested] = useState(null);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prevCount => prevCount + 1); // use functional update to get the latest state
    }, 1000);

    return () => clearInterval(interval); // cleanup on unmount
  }, []);



  useEffect(() => {
    return () => {
      localStorage?.removeItem("MicEnabledForAll");
      localStorage?.removeItem("isClassOver")



    };
  }, []);
  useEffect(() => {
    containerRef.current?.offsetHeight &&
      setContainerHeight(containerRef.current.offsetHeight);
    containerRef.current?.offsetWidth &&
      setContainerWidth(containerRef.current.offsetWidth);

    window.addEventListener("resize", ({ target }) => {
      containerRef.current?.offsetHeight &&
        setContainerHeight(containerRef.current.offsetHeight);
      containerRef.current?.offsetWidth &&
        setContainerWidth(containerRef.current.offsetWidth);
    });
  }, [containerRef]);

  useEffect(() => {
    if (meetingRecord && Object.keys(meetingRecord)?.length > 0) {
      setMeetingRecord(meetingRecord)
    }
  }, [meetingRecord])

  usePubSub("NETWORK_SPEED", {
    onMessageReceived: (data) => {
      try {
        const { senderId, message } = data;
        const { networkSpeed, networkStrengthOfParticipantsPrev = [] } = message;
        const existingIndex = networkStrengthOfParticipantsPrev.findIndex((item) => item.senderId === senderId);
        let updatedArray = [];
        if (existingIndex !== -1) {
          updatedArray = [...networkStrengthOfParticipantsPrev];
          updatedArray[existingIndex] = { senderId, networkSpeed };
        } else {
          updatedArray = [...networkStrengthOfParticipantsPrev, { senderId, networkSpeed }];
        }
        setNetworkStrengthOfParticipants(updatedArray);
      } catch (e) {
        console.log(e)
      }
    }
  });

  const { participantRaisedHand, _handleRemoveOld } = useRaisedHandParticipants();

  const _handleMeetingLeft = () => {
    setIsMeetingLeft(true);

  };



  function onParticipantJoined(participant) {

    participant && participant?.setQuality("high");
    console.log("Mic listttttt", micAllowedParticipantsList);
    if (localStorage?.getItem("MicEnabledForAll") == "True") {
      setMicAllowedParticipantList((prev) => [...prev, participant?.id]);
    }
    else if (localStorage?.getItem("MicEnabledForAll") == "False") {
      setMicAllowedParticipantList((prev) => {
        if (!prev.includes(participant?.id)) return prev;
        return prev.filter((id) => id != participant?.id);
      });
    }
    else if (localStorage?.getItem("WebcamEnabledForAll") == 'False') {
      //in this case , in event message allowed key would be true
      setWebcamAllowedParticipantList((prev) => [...prev, participant?.id])

    } else if (localStorage?.getItem("WebcamEnabledForAll") == "True") {
      setWebcamAllowedParticipantList((prev) => {
        if (!prev.includes(participant?.id)) return prev;
        return prev.filter((id) => id != participant?.id);
      });
    }
    // console.log("onParticipantJoined", participant);
  }


  function onEntryResponded(participantId, name) {

    if (mMeetingRef.current?.localParticipant?.id === participantId) {
      if (name === "allowed") {

        setLocalParticipantAllowedJoin(true);

      } else {
        setLocalParticipantAllowedJoin(false);
        setTimeout(() => {
          _handleMeetingLeft();
        }, 3000);
      }
    }
  }

  function onMeetingLeft() {
    // console.log("onMeetingLeft");
    onMeetingLeave();
  }

  const _handleOnError = (data) => {
    const { code, message } = data;

    const joiningErrCodes = [
      4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010,
    ];

    const isJoiningError = joiningErrCodes.findIndex((c) => c === code) !== -1;


    setMeetingErrorVisible(true);
    setMeetingError({
      code,
      message: isJoiningError ? "Unable to join meeting!" : message,
    });
  };

  const mMeeting = useMeeting({
    onParticipantJoined,
    onEntryResponded,
    onMeetingLeft,
    onError: _handleOnError,

  });
  const setIsScreenShareRequested = (participantId) => {
    setScreenShareRequested(participantId)
  }
  useEffect(() => {
    mMeetingRef.current = mMeeting;
  }, [mMeeting]);
  const isPresenting = mMeeting.presenterId ? true : false;
  usePubSub(`ENABLE_PARTICIPANT_SCREENSHARE`, {
    onMessageReceived: async ({ message }) => {
      if (message?.allowed) {
        if (mMeetingRef.current?.localParticipant?.id === message?.participantId) {
        }
        setIsScreenShareRequested(message?.participantId)
      }
      else if (!message.allowed) {
        if (mMeetingRef.current?.localParticipant?.id === message?.participantId) {
          if (message?.presenterId == mMeetingRef.current?.localParticipant?.id) {
            toggleScreenShare()
          }
        }
        setIsScreenShareRequested(null)
      }
    },
    onOldMessagesReceived: (list) => {
      if (list && Array.isArray(list) && list.length > 0) {
        let obj = list?.[list?.length - 1];
        if (obj?.message?.allowed) {
          // if (mMeetingRef?.current?.localParticipant?.id === message?.participantId) {
          // }
          setIsScreenShareRequested(obj?.message?.participantId)
        }
        else if (!obj?.message?.allowed) {

          setIsScreenShareRequested(null)
        }
      }
    },
  }
  );

  usePubSub("RAISE_HAND", {
    onMessageReceived: (data) => {

      const { senderId, payload } = data;

      if (payload.participantId) {
        setRaisedHandcountcontext(0)
        participantRaisedHand(payload?.participantId, payload.riasedHandCount);
        _handleRemoveOld(payload?.participantId)

      } else {

        participantRaisedHand(senderId, payload.riasedHandCount);

      }

    },
  });


  const { whiteboardUrl } = useWhiteboard();


  const teacherEntries = Array.from(participants.entries())
    .filter(([key]) => key.includes("teacher"));
 
  
  const { webcamOn, webcamStream } = useParticipant(whiteBoardOpenedBy || null);

  // const customDraggableReactPlayerRef = useRef(null);
  const previousMediaStreamRef = useRef(null);
  
  const webcamMediaStream = useMemo(() => {
   

    // Only create mediaStream if whiteboard state has been initialized and conditions are met
    if (whiteboardStateInitialized && webcamOn && webcamStream && whiteBoardActive && teacherEntries?.find(([_, participant]) => participant?.id === whiteBoardOpenedBy)) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      previousMediaStreamRef.current = mediaStream;
      return mediaStream;
    } else {

      return null;
    }
  }, [webcamStream, webcamOn, whiteBoardActive, whiteboardStateInitialized, teacherEntries]);


    const [action, setAction] = useState(null); // 'drag', 'resize', or null
  
    const customDraggableReactPlayerRef = useRef(null);


    useEffect(() => {
      // Don't add listeners if not dragging or resizing
      if (!action) return;
      
      // Function references for event handlers - important to reference these properly
      const handleMouseMove = (e) => {
        if (customDraggableReactPlayerRef.current) {
          customDraggableReactPlayerRef.current.handleMouseMove(e);
        }
      };
      
      const handleEnd = () => {
        if (customDraggableReactPlayerRef.current) {
          customDraggableReactPlayerRef.current.handleEnd();
        }
      };
      
      const handleTouchMove = (e) => {
        if (customDraggableReactPlayerRef.current) {
          customDraggableReactPlayerRef.current.handleTouchMove(e);
        }
      };
      
      // Add event listeners
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleEnd);
      
      // Touch events
      window.addEventListener('touchmove', handleTouchMove, { passive: false });
      window.addEventListener('touchend', handleEnd);
      window.addEventListener('touchcancel', handleEnd);
      
      // Cleanup
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleEnd);
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleEnd);
        window.removeEventListener('touchcancel', handleEnd);
      };
    }, [action]); // Only re-establish listeners when action changes
     


  return (
    <>



      {/* ////// */}
      <div className={`fixed inset-0`}>
        <div ref={containerRef} className="h-full flex flex-col bg-gray-800 reverseCol">
          <FlyingEmojisOverlay />

          {typeof localParticipantAllowedJoin === "boolean" ? (
            localParticipantAllowedJoin ? (
              <>
              

                <div className={` flex flex-1 flex-row bg-gray-800 VidoVisualContainer `}>
                  {meetingMode === Constants.modes.CONFERENCE ? (
                    <div className={`flex flex-1 PosiTionRelative`}
                      style={{ height: containerHeight }}>

                      <div className={`PresentingArea flex ${(isPresenting && !mMeeting.localScreenShareOn) ? "flex-col" : "flex-1 flex-row"} `} style={{ height: containerHeight }}>

                        {isPresenting ? (
                          <PresenterView
                            height={
                              containerHeight - topBarHeight - bottomBarHeight
                            }
                          />
                        ) : null}
                        {(isPresenting) && isMobile ? null : (
                          <MemorizedILSParticipantView
                            isPresenting={isPresenting}
                            comingFromScreenShare={false}
                          />
                        )}


                      
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {(isPresenting && !mMeeting.localScreenShareOn)  && !isMobile && <div className="MainSideBarContainer 2" style={{ height: containerHeight - bottomBarHeight }}><PopOverParticipantVideoRow /></div>}


                </div>

                {/* Bottombar */}
                <ILSBottomBar
                  bottomBarHeight={bottomBarHeight}
                  setIsMeetingLeft={setIsMeetingLeft}
                  selectWebcamDeviceId={selectWebcamDeviceId}
                  setSelectWebcamDeviceId={setSelectWebcamDeviceId}
                  selectMicDeviceId={selectMicDeviceId}
                  setSelectMicDeviceId={setSelectMicDeviceId}
                  meetingMode={meetingMode}
                  // setCustumAudioStream={setCustumAudioStream}
                  webcamAllowedParticipantsList={webcamAllowedParticipantsList}
                  micAllowedParticipantsList={micAllowedParticipantsList}
                  whiteboardAllowedStudents={whiteboardAllowedStudents}

                  screenShareAllowed={screenShareRequested}
                  localParticipantId={mMeetingRef.current?.localParticipant?.id}
                  enableBgImage={enableBgImage}
                  WhiteBoardEnable={WhiteBoardEnable}
                  setWhiteBoardEnable={setWhiteBoardEnable}
                  downloadFunctionCall={downloadFunctionCall}
                  setDownloadFunctionCall={setDownloadFunctionCall}
                  setLecturePdfFilePath={setLecturePdfFilePath}
                  lecturePdfFilePath={lecturePdfFilePath}
                  clearWhiteBoardData={clearWhiteBoardData}
                  setClearWhiteBoardData={setClearWhiteBoardData}
                  saveWhiteBoardData={saveWhiteBoardData}
                  setSaveWhiteBoardData={setSaveWhiteBoardData}
                  action={action}
                //  timeLeft={timeLeft}
                />

              </>
            ) : (
              <div>Errorrro</div>
            )
          ) : (
            !mMeeting.isMeetingJoined && <><WaitingToJoinScreen /></>
          )}
      {whiteBoardActive && (whiteboardUrl || whiteboardUrlStored) && timer>0 && webcamMediaStream && whiteBoardOpenedBy &&
          <CustomDraggableReactPlayer
            ref={customDraggableReactPlayerRef}
            action={action}
            setAction={setAction}
            mediaStream={webcamMediaStream}
            containerWidth={180}
            containerHeight={133}
          />
        }
        </div>
      </div>
    </>
  );
}
